import React from 'react'
import PropTypes from 'prop-types'
import Switch from '../Switch/Switch'
import BureauGrid from './BureauGrid'
import { TITLE, ADMIN_SUFFIX, SHOWN_LABEL, shownText, ADMIN_HELPER } from './copy'

const ContactCreditScores = ({ data, canEdit, onToggle, saving }) => (
  <div className="grid gap-3 rounded-2xl border border-divider bg-surface p-5 shadow-subtle dark:shadow-none">
    <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
      <h5 className="m-0 text-md font-semibold text-text-primary">
        {TITLE} <span className="font-normal text-text-secondary">{ADMIN_SUFFIX}</span>
      </h5>
      {canEdit ? (
        <Switch
          checked={Boolean(data.shownInPortal)}
          onChange={(next) => onToggle(next)}
          disabled={Boolean(saving)}
          label={SHOWN_LABEL}
          id="shown-in-client-portal"
          size="sm"
        />
      ) : (
        <span className="text-[13px] font-medium text-text-primary">{shownText(data.shownInPortal)}</span>
      )}
    </div>
    <p className="m-0 text-[13px] text-text-secondary">{ADMIN_HELPER}</p>
    <BureauGrid bureaus={data.bureaus} showChart={data.reportDayCount > 1} compact />
  </div>
)

ContactCreditScores.propTypes = {
  data: PropTypes.object.isRequired,
  canEdit: PropTypes.bool,
  onToggle: PropTypes.func,
  saving: PropTypes.bool,
}

export default ContactCreditScores
